import React, { PureComponent } from "react";
import classes from "./ThirdBlock.module.css";
import cn from "clsx";
import Typography from "src/components/ui-kit/Typography";
import Button from "src/components/ui-kit/Button";
import { trackCustomEvent } from "gatsby-plugin-google-analytics";

interface ThirdBlockProps {}

class ThirdBlock extends PureComponent<ThirdBlockProps> {
  render(): React.ReactNode {
    return (
      <div className={cn(classes.container)}>
        <Typography
          variant="h1"
          component="h3"
          color="primary"
          className={cn(classes.heading)}
        >
          <b>
            Дружи, забирай,
            <br />
            гладь, люби!
          </b>
        </Typography>
        <Typography
          variant="h3"
          component="p"
          isSemiTransperent
          color="primary"
        >
          <b>Каждому нужен надежный друг</b>
        </Typography>
        <Button
          onClick={this.handleBecomeOwnerClick}
          className={cn(classes.button)}
          href="https://fundvet.city/pets"
        >
          <img src={require("./heart.svg")} alt="Иконка сердца" />
          <Typography variant="h3" component="span" color="inverted">
            ИЩУТ ДОМ. ДАВАЙТЕ ЗНАКОМИТЬСЯ
          </Typography>
        </Button>
      </div>
    );
  }

  private handleBecomeOwnerClick = () => {
    trackCustomEvent({
      category: "button",
      action: "g_m_meet",
    });
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.ym(53234908, "reachGoal", "y_m_meet");
  };
}

export default ThirdBlock;
